/*eslint-disable*/
import React from "react";
import { Input, FormGroup } from "reactstrap";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import {STYLES} from "config";
function CommisionDetailsComponent(props) {
  const { data, setvalue } = props;
  return (
    <>
      <FormGroup
        style={{
          fontSize: 35,
          fontWeight: "400",
          margin: "10px 0 0 1px",
          color: STYLES.WEB_APP_FONT_CLR,
        }}
      >
        <span>Commission </span>
      </FormGroup>
      <hr
        style={{
          color: STYLES.WEB_APP_FONT_CLR
        }}
      />
      <div className="p-6 text-gray-900">
        <h6>
          Description
        </h6>
      </div>
      <hr
        style={{
          color: STYLES.WEB_APP_FONT_CLR
        }}
      />
      <GridItem xs={12} sm={12} md={12} lg={12}>
        <GridContainer spacing={1}>
          <GridItem xs={2}>
            <FormGroup
              style={{
                fontSize: 15,
                fontWeight: "400",
                margin: "10px 0 0 1px",
                color: STYLES.WEB_APP_FONT_CLR,
              }}
            >
              <span>Commision Percentage : </span>
            </FormGroup>
          </GridItem>
          <GridItem xs={10}>
            <Input
              //returnKeyType={'next'}
              type="select"
              fullWidth
              bsSize="lg"
              // placeholder={"practice name"}
              value={data?.commission}
              onChange={(event) => {
                setvalue({
                  ...data,
                  commission: event.target.value,
                });
              }}
              customLabelStyles={{
                colorFocused: STYLES.TERTIARY_APP_CLR,
                colorBlurred: "black",
                fontSizeFocused: 12,
              }}
              style={{
                fontSize: 15,
                fontWeight: "400",
                border: "1px solid",
                borderColor: STYLES.PRIMARY_APP_CLR,
                color: STYLES.WEB_APP_FONT_CLR,
              }}
              >
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="30">30</option>
              <option value="40">40</option>
              <option value="50">50</option>
              <option value="100">100</option>
              </Input>
          </GridItem>

          <GridItem xs={2}>
            <FormGroup
              style={{
                fontSize: 15,
                fontWeight: "400",
                margin: "10px 0 0 1px",
                color: STYLES.WEB_APP_FONT_CLR,
              }}
            >
              <span>Comision Value(R) : </span>
            </FormGroup>
          </GridItem>
          <GridItem xs={10}>
            <Input
              //returnKeyType={'next'}
              type="text"
              fullWidth
              bsSize="lg"
              value={data?.commission}
              onChange={(event) => {
                setvalue({
                  ...data,
                  commission: event.target.value,
                });
              }}
              style={{
                fontSize: 15,
                fontWeight: "400",
                border: "1px solid",
                borderColor: STYLES.PRIMARY_APP_CLR,
                color: STYLES.WEB_APP_FONT_CLR,
              }}
              customLabelStyles={{
                colorFocused: STYLES.TERTIARY_APP_CLR,
                colorBlurred: "black",
                fontSizeFocused: 12,
              }}
            />
          </GridItem>
          <GridItem xs={2}>
            <FormGroup
              style={{
                fontSize: 15,
                fontWeight: "400",
                margin: "10px 0 0 1px",
                color: STYLES.WEB_APP_FONT_CLR,
              }}
            >
              <span>Commission Sell_List Split : </span>
            </FormGroup>
            {/* 
            <FormText>Article Description :</FormText> */}
          </GridItem>
          <GridItem xs={10}>
            <Input
              //returnKeyType={'next'}
              fullWidth
              bsSize="lg"
              type="text"
              // placeholder={"service type"}
              value={data?.commissionSellListSplit}
              onChange={(event) => {
                setvalue({
                  ...data,
                  commissionSellListSplit: event.target.value,
                });
              }}
              style={{
                fontSize: 15,
                fontWeight: "400",
                border: "1px solid",
                borderColor: STYLES.PRIMARY_APP_CLR,
                margin: "10px 0 0 1px",
                color: STYLES.WEB_APP_FONT_CLR,
              }}
            />
          </GridItem>
          <GridItem xs={2}>
            <FormGroup
              style={{
                fontSize: 15,
                fontWeight: "400",
                margin: "10px 0 0 1px",
                color: STYLES.WEB_APP_FONT_CLR,
              }}
            >
              <span>Comision Split Notes : </span>
            </FormGroup>
            {/* 
            <FormText>Article Description :</FormText> */}
          </GridItem>
          <GridItem xs={10}>
            <Input
              //returnKeyType={'next'}
              fullWidth
              bsSize="lg"
              type="textarea"
              // placeholder={"service type"}
              value={data?.commissionSplitNotes}
              onChange={(event) => {
                setvalue({
                  ...data,
                  commissionSplitNotes: event.target.value,
                });
              }}
              style={{
                fontSize: 15,
                fontWeight: "400",
                border: "1px solid",
                borderColor: STYLES.PRIMARY_APP_CLR,
                margin: "10px 0 0 1px",
                color: STYLES.WEB_APP_FONT_CLR,
              }}
            />
          </GridItem>
        </GridContainer>
      </GridItem>
    </>
  );
}
export default CommisionDetailsComponent;
